// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FcC6","rootNoMargin":"styles_rootNoMargin__1xBsk"};